module.exports = __webpack_public_path__ + "img/3-fr.fc88d55f.jpg";